export default "__VITE_ASSET__BBHjvVuC__"